
























































































































import { defineComponent } from '~/utils/nuxt3-migration'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { mapGetters, mapState } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { toCamelCase } from '~/utils/object'
import FeedSideButton from '~/components/car/classifieds/index/feeds/sidebar/FeedSideButton.vue'
import FeedSidebarIconContainer from '~/components/car/classifieds/index/feeds/sidebar/FeedSidebarIconContainer.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { ciAngleDown } from '~/icons/source/light/angle-down'
import { ciMyClassifieds } from '~/icons/source/regular/my-classifieds'
import { ciEnvelope } from '~/icons/source/regular/envelope'
import { ciParking } from '~/icons/source/regular/parking'
import { ciBell } from '~/icons/source/regular/bell'
import { ciUserPlus } from '~/icons/source/regular/user-plus'
import { ciSignInAlt } from '~/icons/source/regular/sign-in-alt'
import RouteGuardService from '~/services/RouteGuardService'
import { ciHeart } from '~/icons/source/solid/heart'

interface Data {
  myClassifieds: object[]
  userOpen: boolean
}
export default defineComponent({
  components: {
    FeedSidebarIconContainer,
    FeedSideButton,
    CAvatar
  },
  async mounted() {
    if (!this.isAnon && !this.isAuditsUser) {
      await this.fetchMyClsfds()
    }
  },
  data(): Data {
    return {
      myClassifieds: [],
      userOpen: false
    }
  },
  computed: {
    ...mapState(USER_NS, {
      username: 'name',
      avatar: 'avatar',
      unreadNotifications: 'unreadNotifications',
      msgCount: 'unreadMessages',
      parkingCount: 'unreadParkingNotifications'
    }),
    ...mapGetters(USER_NS, {
      isDealer: 'isOfTypeDealer',
      isAdmin: 'isAdmin',
      isGuest: 'isGuest',
      isAnon: 'isSingleOrAnon',
      isAuditsUser: 'isAuditsUser'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapDeps({
      legacyUrlService: LegacyUrlService,
      routeGuardService: RouteGuardService
    }),
    icons() {
      return {
        folder: ciMyClassifieds,
        envelope: ciEnvelope,
        chevronDownsm: ciAngleDown,
        parking: ciParking,
        register: ciUserPlus,
        login: ciSignInAlt,
        bell: ciBell,
        heart: ciHeart
      }
    },
    messagesLink() {
      if (this.isDealer || this.isAdmin || this.isGuest) {
        return this.$router.resolve({
          name: '__account_messages'
        }).href
      }

      return null
    },
    registerLink() {
      return this.legacyUrlService.getRegisterUrl({ 'from-index': 1 })
    },
    parkingLinks() {
      return {
        label: this.$t('favorite classifieds'),
        url: '/parking/',
        icon: this.icons.heart,
        notifications: this.parkingCount || 0
      }
    },
    hasAccessToParking() {
      return this.routeGuardService.userHasAccessToParking()
    }
  },
  methods: {
    async fetchMyClsfds() {
      const { data } = await this.$axios.get('/api/user/classifieds/counts/')

      if (data.data) {
        this.myClassifieds = toCamelCase(data.data.states)
      }
    },
    toggleUserOpen() {
      this.userOpen = !this.userOpen
      this.$emit('user-open', this.userOpen)
    },
    controlPanelClicked(e) {
      e.preventDefault()
      this.$analytics.recordEvent({
        namespace: 'n_index_control_panel_click',
        action: 'click'
      })
      window.location.href = '/account/'
    },
    messagesClicked(e) {
      e.preventDefault()
      this.$analytics.recordEvent({
        namespace: 'n_index_messages_click',
        action: 'click'
      })

      window.location.href = this.messagesLink
    },
    registerClicked(e) {
      e.preventDefault()
      this.$analytics.recordEvent({
        namespace: 'n_index_register_click',
        action: 'click'
      })
      window.location.href = this.registerLink
    },
    loginClicked(e) {
      e.preventDefault()
      this.$analytics.recordEvent({
        namespace: 'n_index_login_click',
        action: 'click'
      })
      window.location.href = '/login/'
    },
    offerClicked(e) {
      e.preventDefault()
      this.$analytics.recordEvent({
        namespace: 'n_index_sidebar_offer_clicked',
        action: 'click'
      })
      window.location.href = this.legacyUrlService.offerBtnLink()
    }
  }
})
